import { classnames } from "lib/helpers";
import { useEffect, useRef } from "react";

function CloseButton({ closeTab }) {
  function onClick(e) {
    e.stopPropagation();
    closeTab();
  }
  // prevent drag listeners from interfering with onClick event
  function onMouseDown(e) {
    e.stopPropagation();
  }
  return <button {...{ onClick, onMouseDown }}>&times;</button>;
}

export default function Tab({
  children,
  select,
  active,
  tab,
  detachTab,
  closeTab,
  parent,
  disableWindow,
  onlyChild,
  dragging,
}) {
  const { name: title } = tab;
  const ref = useRef();
  const pos = useRef();
  useEffect(() => {
    if (dragging === tab.name) {
      document.onmousemove = (e) => {
        // TODO: check if necessary
        if (!pos.current) return;
        const { clientX, clientY, x, y, height, width } = pos.current;
        const top = clientY - e.clientY;
        const left = clientX - e.clientX;
        pos.current.clientX = e.clientX;
        pos.current.clientY = e.clientY;
        const el = parent.current;
        el.style.top = el.offsetTop - top + "px";
        el.style.left = el.offsetLeft - left + "px";
        const xOutside = e.clientX > x + width || e.clientX < x;
        const yOutside = e.clientY > y + height || e.clientY < y;
        // console.log('[', width, height, ']', '[', x, y, '][', e.clientX, e.clientY, ']')
        const outside = xOutside || yOutside;
        if (outside && !onlyChild) detachTab();
      };
      document.onmouseup = (e) => {
        e.stopPropagation();
        document.onmousemove = null;
        document.onmouseup = null;
        // dataTransfer unset upon successful tab drop
        // in which case not needed to do here
        if (window.dataTransfer) {
          window.dataTransfer = null;
          disableWindow(false);
        }
        window.selectWindow = tab.name;
      };
    }
  }, [detachTab, disableWindow, dragging, onlyChild, parent, select, tab.name]);
  useEffect(() => {
    if (!dragging && window.selectWindow) {
      if (window.selectWindow === tab.name) select();
    }
  }, [dragging, select, tab.name]);
  function onMouseDown(e) {
    e.stopPropagation();
    const rect = ref.current.getBoundingClientRect();
    pos.current = {
      clientX: e.clientX,
      clientY: e.clientY,
      x: rect.left,
      y: rect.top,
      width: e.target.offsetWidth,
      height: e.target.offsetHeight,
    };
    disableWindow(tab.name);
    window.dataTransfer = {
      type: "TAB",
      tab,
    };
    document.body.style.cursor = "grabbing";
  }
  return (
    <div
      className={classnames("wx-tb", { a: active })}
      {...{ ref, onMouseDown }}
    >
      {children}
      <span role="tab">
        {typeof title === "function" ? title(active) : title}
      </span>
      <CloseButton {...{ closeTab }} />
    </div>
  );
}
